const REGEXP_ESCAPE = {
    '0': 'x30',
    '1': 'x31',
    '2': 'x32',
    '3': 'x33',
    '4': 'x34',
    '5': 'x35',
    '6': 'x36',
    '7': 'x37',
    '8': 'x38',
    '9': 'x39',
    A: 'x41',
    B: 'x42',
    C: 'x43',
    D: 'x44',
    E: 'x45',
    F: 'x46',
    a: 'x61',
    b: 'x62',
    c: 'x63',
    d: 'x64',
    e: 'x65',
    f: 'x66',
    n: 'x6e',
    r: 'x72',
    t: 'x74',
    u: 'x75',
    v: 'x76',
    x: 'x78',
};

const STRING_ESCAPE = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029',
};

type RegexpChar = keyof typeof REGEXP_ESCAPE;
type StringChar = keyof typeof STRING_ESCAPE;

const REGEX = /^[:!,]|[\\^$.*+?()[\]{}|/]|(^[0-9a-fA-Fnrtuvx])|([\n\r\u2028\u2029])/g;
const ESCAPE_PREFIX = '\\';

const escapeRegExpChar = (char: string, leadingChar: string, whitespaceChar: string): string => {
    if (leadingChar) {
        return `${ESCAPE_PREFIX}${REGEXP_ESCAPE[char as RegexpChar]}`;
    }

    if (whitespaceChar) {
        return `${ESCAPE_PREFIX}${STRING_ESCAPE[char as StringChar]}`;
    }

    return `${ESCAPE_PREFIX}${char}`;
};

export const escapeRegExp = (text?: string): string => {
    if (!text) {
        return '(?:)';
    }

    if (!REGEX.test(text)) {
        return text;
    }

    return text.replace(REGEX, escapeRegExpChar);
};
